// extracted by mini-css-extract-plugin
module.exports = {"root":"Help_root__32W1I","img":"Help_img__HDx8i","imgRight":"Help_imgRight__DGkVn"};